import styled from 'styled-components';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';

export const CustomHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRight: `1px solid ${theme.colors.neutral[400]}`,
  borderLeft: `1px solid ${theme.colors.neutral[400]}`,
  borderImage: `linear-gradient(to top, ${theme.colors.neutral[400]} 52%, transparent 50%) 100% 1`,
  borderImageSlice: 1,

  '&:after, &:before': {
    content: '""',
    height: '1px',
    backgroundColor: theme.colors.neutral[400],
    flexGrow: 1,
  },

  '&:before': {
    marginRight: theme.space[40],
  },

  '&:after': {
    marginLeft: theme.space[40],
  },
}));
